import { render } from "./IconNextItem.vue?vue&type=template&id=35bb3347"
import script from "./IconNextItem.vue?vue&type=script&lang=js"
export * from "./IconNextItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__